<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label="iv" class="page" id="piv" role="doc-pagebreak"></span>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2021 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2021</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">30 29 28 27 26 25 24 23 22 21    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-78276-8 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-78293-5 (paper)</p>
<p class="crt">ISBN-13: 978-0-226-78309-3 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226783093.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226783093.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip">Names: Seneca, Lucius Annaeus, approximately 4 B.C.–65 A.D., author. | Graver, Margaret, translator, writer of supplementary textual content. | Long, A. A., translator, writer of supplementary textual content.</p>
<p class="cip">Title: Seneca : fifty letters of a Roman Stoic / Lucius Annaeus Seneca ; translated with an introduction and commentary by Margaret Graver and A. A. Long</p>
<p class="cip">Other titles: Epistulae morales ad Lucilium. Selections. English. 2021 | Fifty letters of a Roman Stoic</p>
<p class="cip">Description: Chicago ; London : The University of Chicago Press, 2021. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2021009510 | ISBN 9780226782768 (cloth) | ISBN 9780226782935 (paperback) | ISBN 9780226783093 (ebook)</p>
<p class="cip">Subjects: LCSH: Ethics—Early works to 1800. | Stoics—Early works to 1800.</p>
<p class="cip">Classification: LCC PA6665.A1 2021 | DDC 876/.01—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2021009510" target="_blank">https://lccn.loc.gov/2021009510</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI<span class="sm">/</span>NISO Z39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-seneca-0004.vue?3eec6953